module.exports = __webpack_public_path__ + "img/league_best_banner.957082c3.png";